G.MissionTitlePanel = function(x, y, config) {
    Phaser.Group.call(this, game);
    this.position.setTo(x, y);
  
    this.ribbon = G.makeImage(10, 25, config.ribbon, [0.5, 0], this);
    // this.ribbon.width = 350;
  
    this.text = new G.Text(0, 20, config.text, {
      style: "font-white",
      fontSize: 50,
    }, 0.5, 260);
    this.add(this.text);
  
  };
  
  G.MissionTitlePanel.prototype = Object.create(Phaser.Group.prototype);
  
  G.MissionTitlePanel.prototype.getContentHeight = function() {
    return this.height + 40//;
  };
  
  G.MissionTitlePanel.prototype.show = function(immediate, delay) {
    G.stopTweens(this.ribbon.scale);
  
    if (immediate) {
      this.scale.setTo(1);
    } else {
      game.add.tween(this.scale)
        .to({x: 1, y: 1}, 500, Phaser.Easing.Custom.SoftBounce, true, delay || 0);
    }
  };
  
  G.MissionTitlePanel.prototype.hide = function(immediate, delay) {
    G.stopTweens(this.ribbon.scale);
  
    if (immediate) {
      this.scale.setTo(0);
    } else {
      game.add.tween(this.scale)
        .to({x: 0, y: 0}, 500, Phaser.Easing.Custom.SoftBounce, true, delay || 0);
    }
  };
  